import axios from "../../../api/axios";

export const fetchSuchanas = async () => {
    return axios.get('/suchana').then(res=>res.data)
}

export const fetchSuchanaById = async (id) => {
    return axios.get(`/suchana?id=${id}`).then(res=>res.data)
}
